import { useCallback } from 'react';
import { 
    getCompanionSettings as getCompanionApi,
    updateCompanionSettings as updateCompanionApi,
} from '../api/Companion'
import type { CompanionSettings } from "@common/domain/types";
import { useUserInfoContext } from '../contexts/UserInfoContext';

export const useCompanion = () => {
    const { userInfo } = useUserInfoContext();

    const getCompanionSettings = useCallback(async (personaId: string) => {
        try {
            return await getCompanionApi(userInfo, personaId);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    const updateCompanionSettings = useCallback(async (personaId: string, updates: Partial<CompanionSettings>) => {
        try {
            return await updateCompanionApi(userInfo, personaId, updates);
        } catch (error) {
            throw error
        }
    }, [userInfo]);

    return {
        getCompanionSettings,
        updateCompanionSettings
    }
}